import { jsx as _jsx } from "react/jsx-runtime";
import { resolveResponsiveRangeProps, resolveResponsiveRangeFlatPropsOptional, } from '../../library/props/responsiveRangeProps';
import { Box } from '../Box/Box';
import * as styles from './Hidden.css';
export const Hidden = ({ children, above, below, print, inline, ...allBoxDataProps }) => {
    const hiddenOnPrint = Boolean(print);
    const rangeProps = resolveResponsiveRangeProps({ above, below });
    const display = inline ? 'inline' : 'block';
    const responsiveDisplay = resolveResponsiveRangeFlatPropsOptional(rangeProps, 'none', display);
    return (_jsx(Box, { display: responsiveDisplay, className: hiddenOnPrint ? styles.hiddenOnPrint : undefined, component: inline ? 'span' : 'div', ...allBoxDataProps, children: children }));
};
